import { useEffect } from "react";
import { useJourneyStore } from "../game/state/journeyMachine";

/**
 * Sincroniza la preferencia de reducción de movimiento:
 *  - Inicializa desde prefers-reduced-motion.
 *  - Expone el toggle al estado global.
 */
export function useReducedMotionSync(): void {
  const setReducedMotion = useJourneyStore((s) => s.setReducedMotion);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReducedMotion(mq.matches);
    const onChange = (e: MediaQueryListEvent) => setReducedMotion(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [setReducedMotion]);
}

export function ReducedMotionToggle() {
  const reducedMotion = useJourneyStore((s) => s.reducedMotion);
  const setReducedMotion = useJourneyStore((s) => s.setReducedMotion);

  return (
    <label className="flex items-center gap-2 text-sm">
      <input
        type="checkbox"
        checked={reducedMotion}
        onChange={(e) => setReducedMotion(e.target.checked)}
      />
      Reducir movimiento
    </label>
  );
}
